import React, { useEffect, useState } from 'react'
import { useConfig } from '../../contexts/config/use'
import useTheme from '@material-ui/core/styles/useTheme'
import { useTranslation } from '../../contexts/i18n/use'
import { Box, Button, CircularProgress, Divider, FormControl, TextField, Typography } from '@material-ui/core';
import { Confirmation } from './confirmation'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Header } from '../header';
import { isFalsyOrEmpty } from '../helpers/object'
import { GetParametersFromHash } from '../helpers/search'
import { useHistory } from "react-router-dom"
import { Queuedata } from '../../services/dto/queuedata.dto'
import { useRest } from '../../contexts/rest/use';
import { TicketFailureModal } from '../queue_selection_page/ticketfailuremodal'
import { ClearOutdatedStorage } from '../helpers/clearstorage';

export const FormsPage = () => {
  const { state: { config }, actions: {GetFormData, GetFormName, GetOfficeIDFromUrlID, GetQueueIDfromUrlID, ReloadConfiguration, GetUrlIDFromOfficeID}} = useConfig();
  const { state: { selectedoffice, wasticketfailure }, actions: { handleTakeTicket,  qrToFormsSelection}} = useRest();
  const { actions: {t, dt}} = useTranslation();
  const [disablebuttons, setDisableButtons] = useState(false);
  const [failure, setFailure] = useState(null);
  const [queuedata, setQueueData] = useState();
  const [required, setRequired] = useState();
  const [formdata, setFormData] = useState();
  const [formname, setFormName] = useState();
  const [forms, setForms] = useState();
  const [modal, setModal] = useState();
  const [ispristine, setIsPristine] = useState(true);
  const theme = useTheme();
  const history = useHistory();
  const classes = useStyles(theme);

  useEffect(() => {
    if (config)
    {
      var oldbaseurl = localStorage.getItem("baseurl");
      if (window.location.pathname !== oldbaseurl)
      {
        ClearOutdatedStorage();
        localStorage.setItem("baseurl", window.location.pathname);
        ReloadConfiguration();
        window.location.reload();
        return;
      }
  
      var ticket = JSON.parse(localStorage.getItem("ticket"));
      if(!isFalsyOrEmpty(ticket) && !ticket.cancelled)
      {
        history.push('ticket')
        return;
      }
      const searchParams = GetParametersFromHash();
      if (searchParams)
      {
        if (searchParams.officeID && searchParams.queueID)
        {
          searchParams.officeID = GetOfficeIDFromUrlID(searchParams.officeID);
          searchParams.queueID = GetQueueIDfromUrlID(searchParams.officeID, searchParams.queueID);
          var tmpqueuedata = new Queuedata(searchParams.queueID, searchParams.segmentID, searchParams.serviceID);
          setQueueData(tmpqueuedata);
          qrToFormsSelection(searchParams.officeID, tmpqueuedata);
        }
        else
          history.push("404");
      }
      else
      {
        let officeID = localStorage.getItem("selectedoffice");
        let queueID = localStorage.getItem("selectedqueue");
        let segmentID = sessionStorage.getItem("segementID");
        let serviceID = sessionStorage.getItem("serviceID");
  
        if (!officeID && (!queueID || (!segmentID && !serviceID)))
          history.push("/");
      }
    }
  }, [config])

  useEffect(() => {
    if (queuedata)
      generate(queuedata);
    
  },[queuedata])

  useEffect(() => {
    if (wasticketfailure)
      setFailure(true);
    else 
      setFailure(null);
  },[wasticketfailure])

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsPristine(false);
    if (validateAll())
    {
      setDisableButtons(true);
      setModal(true);
    }
  }

  const cancelModal = () => {
    setModal(false);
    setDisableButtons(false);
  }

  const takeTicket = () => {
    setModal(false);
    var officeid = localStorage.getItem("selectedoffice");
    var text = getConfirmationText(officeid, queuedata, true);
    var tickettext;
    if (text)
    {
      tickettext = text.map(x => x.value.toString()).join(',');
      if(tickettext === null){
        tickettext='';
      }
      localStorage.setItem("tickettext", JSON.stringify(text));
      localStorage.setItem("formname", formname);
    }
    handleTakeTicket(officeid, queuedata, null, tickettext);
  }

  const getConfirmationText = (officeID, serviceinfo, notranslate = false) => {
    var tmpforms = GetFormData(officeID, serviceinfo);
    var items = null;
      var values = JSON.parse(sessionStorage.getItem("formdata"));
      if (values)
      {
        items = tmpforms.map((x, i) => { 
          if (x.type === "textbox")
            return {id: notranslate ? x.id : dt(officeID, x.id), value: values[i]}
          else
            return {}
        })
      }
      var nonemptyitems = items.filter(x => !isFalsyOrEmpty(x));
      var filtereditems = nonemptyitems.filter(x => !isFalsyOrEmpty(x.value));
      return filtereditems;
  }

  const GenerateConfirmation = (officeID, serviceinfo) => {
    var items = getConfirmationText(officeID, serviceinfo);

    if (isFalsyOrEmpty(items))
      //return <span/>
      return (
        <Confirmation items={items} cancel={cancelModal} confirm={takeTicket}/>
      )
    else
      return (
        <Confirmation items={items} cancel={cancelModal} confirm={takeTicket}/>
      )
  }

  const validate = (required, value, pristine = true) => {
    if (pristine)
      return true;
    if (required && !value)
      return false;
    return true;
  }

  const validateAll = () => {
    var values = JSON.parse(sessionStorage.getItem("formdata"));
    setIsPristine(false);
    var valid = true;
    for(var i = 0; i <= values.length; i++)
    {
      if (!validate(required[i], values[i], false))
        valid = false;
    }
    return valid;
  }

  const handleGoBack = () => {
    sessionStorage.removeItem("formdata");
    localStorage.removeItem("selectedqueue");
    localStorage.removeItem("selectedqueuename");
    const oid = GetUrlIDFromOfficeID(localStorage.getItem("selectedoffice"));
    history.push("queues?officeID=" + oid);
  }

  const handleChange = (e, index) => {
    if (config)
    {
      // TODO: Add error messages
      if (config.forbiddenInputs.some(x => e.target.value.includes(x)))
        return;
      if (e.target.value.length > config.maxInputLength)
        return;

      var values = JSON.parse(sessionStorage.getItem("formdata"));
      var before;
      var object = [e.target.value];
      var after;
      if (index === 0)
      {
        if (values.length > 1)
        {
          after = values.slice(index+1);
          sessionStorage.setItem("formdata", JSON.stringify(object.concat(after)));
          setFormData(object.concat(after));
          return;
        }
        else
        {
          sessionStorage.setItem("formdata", JSON.stringify(object));
          setFormData(object);
        }  
      }
      else if (index === values.length -1)
      {
        before = values.slice(0, index);
        sessionStorage.setItem("formdata", JSON.stringify(before.concat(object)));
        setFormData(before.concat(object));
        return;
      }
      else
      {
        before = values.slice(0, index);
        sessionStorage.setItem("formdata", JSON.stringify(before.concat(object).concat(values.slice(index +1))));
        setFormData(before.concat(object).concat(values.slice(index +1)));
        return;
      }
    }
  }

  const generate = (queuedata) => {
    let officeID = localStorage.getItem("selectedoffice");
    var forms = GetFormData(officeID, queuedata);
    var fname = GetFormName(officeID, queuedata);
    setFormName(fname);
    localStorage.setItem("formname", fname);

    if (isFalsyOrEmpty(forms))
      return null;
    var reqs = forms.map(x => x.required);
    setRequired(reqs);
    setForms(forms);
    var oldformdata = JSON.parse(sessionStorage.getItem("formdata"));
    if (isFalsyOrEmpty(oldformdata))
    {
      var vals = forms.map(x => {return ""});
      sessionStorage.setItem("formdata", JSON.stringify(vals));
      setFormData(vals);
    }
    else
      setFormData(oldformdata);
  }


if (forms && formdata && config)
  {
    return (
      <>
      <Header/>
      <Box  className={classes.container}>
        { modal ? GenerateConfirmation(selectedoffice, queuedata) : <span/>}
        { failure ? <TicketFailureModal disablecallback={cancelModal}/> : <></>}
        <form className={classes.formswrapper} onSubmit={handleSubmit}>
          { forms.map((x,i) => {
            if (x.type === "label")
              return (
                <FormControl className={classes.formcontrol}>
                  <Typography className={"formspage-labels"}>{dt(selectedoffice, x.id)}</Typography>
                </FormControl>
              )
            if (x.type === "textbox")
              return (
                <FormControl className={classes.formcontrol}>
                  <TextField 
                    disabled={disablebuttons}
                    label={dt(selectedoffice, x.id) || ""} 
                    defaultValue={formdata[i]}
                    error={x.required && !validate(x.required, formdata[i], ispristine)} 
                    helperText={!validate(x.required, formdata[i], ispristine) && t('formspage.incomplete') }
                    required={x.required} 
                    onChange={(e) => handleChange(e, i)}
                    className={[classes.textfield, "formspage-textbox"].join(' ')}
                    InputProps={{ classes: {root: classes.root, focused: classes.focused}}}
                    inputProps={{title: t('formspage.input.errorhelp')}}
                    variant="outlined"
                    size="small"
                    value={formdata[i]}
                    fullWidth={true}
                  />
                </FormControl>
              )
              else
                return null;
          })} 
        <Divider variant="middle" className={classes.divider} />
        <Box className={classes.buttonwrapper}>
          <Button 
            disabled={disablebuttons}
            type="button" 
            className={[classes.button, "dialogbutton"].join(' ')} 
            id="formspage-buttons-back" 
            onClick={handleGoBack}
            >
              {t('formspage.backbutton')}
            </Button>
          <Button 
            disabled={disablebuttons}
            type="submit" 
            className={[classes.button, "dialogbutton"].join(' ')} 
            id="formspage-buttons-submit"
            >
              {t('formspage.submitbutton')}
          </Button>
        </Box>
        </form>
      </Box>
      </>
    )
  }
  else
  {
    return (
      <Box className={classes.container}>
        <Box className={classes.formswrapper}>
          <CircularProgress/>
        </Box>
      </Box>
    )
  }
}

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    overflow: 'auto'
  },
  formswrapper: {
    flex: '1 1 auto',
    display: 'flex',
    width: '100%',
    maxWidth: '600px',
    flexDirection: 'column',
    justifyContent: 'center',
    justifyItems: 'center',
    alignItems: 'center',
    paddingTop: '1rem'
  },
  formcontrol:{
    width: '90%'
  },
  textfield: {
    width: '100%',
    margin: '0.5rem 0'
  },
  button: (theme) => ({
    display: 'inline-block',
    backgroundColor: theme.palette.button_text.main,
    color: theme.palette.listitem.main,
    borderRadius: '0',
    border: 'none',
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.button_text.main,
        color: theme.palette.listitem.main
      }
    }
  }),
  buttonwrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: '1rem 0',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginTop: 'auto',
    width: '100%'
  },
  divider: {
    marginTop: '0.5rem',
    marginBottom: '0.5rem'
  },
  root: {
    "&$focused": {
      
    },
  },
  error: {},
  focused: { }
}))